import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GLOBAL_FILTER } from '../navigator/navigatorPortalNames';
import RenderToPortal from "../../../components/portals/RenderToPortal";
import { AppLocationFilter } from "./AppLocationFilter"

/** 
 * component that portals children to render in the global filter.
 * Note: Does not render inline if AppPage does not provide a GLOBAL_FILTER portal
*/
export function UseGlobalFilter({ children }) {
  return <RenderToPortal id={GLOBAL_FILTER}>{children}</RenderToPortal>
}

UseGlobalFilter.propTypes = {
  /** Component to be rendered in the global filter position of the AppLayout */
  children: PropTypes.element,
  ...AppLocationFilter.propTypes
}

/** 
 * Installs AppLocationFilter dropdown into the current AppLayout while mounted
 **/
export function UseLocationFilter(locationFilterProps) {
  return <UseGlobalFilter><AppLocationFilter {...locationFilterProps} /></UseGlobalFilter>
}

UseLocationFilter.propTypes = AppLocationFilter.propTypes
